import {
  FETCH_NDT_ANALYTICS,
  FETCH_NDT_ANALYTICS_SUCCESS,
  FETCH_NDT_ANALYTICS_FAILURE,
  FETCH_AI_INSIGHTS,
  FETCH_AI_INSIGHTS_SUCCESS,
  FETCH_AI_INSIGHTS_FAILURE,
  CLEAR_NDT_ANALYTICS
} from './types';

// Fetch NDT Analytics
export const fetchNDTAnalytics = (payload) => ({
  type: FETCH_NDT_ANALYTICS,
  payload
});

export const fetchNDTAnalyticsSuccess = (payload) => ({
  type: FETCH_NDT_ANALYTICS_SUCCESS,
  payload
});

export const fetchNDTAnalyticsFailure = (error) => ({
  type: FETCH_NDT_ANALYTICS_FAILURE,
  error
});

// Fetch AI Insights
export const fetchAIInsights = (payload) => ({
  type: FETCH_AI_INSIGHTS,
  payload
});

export const fetchAIInsightsSuccess = (payload) => ({
  type: FETCH_AI_INSIGHTS_SUCCESS,
  payload
});

export const fetchAIInsightsFailure = (error) => ({
  type: FETCH_AI_INSIGHTS_FAILURE,
  error
});

// Clear NDT Analytics
export const clearNDTAnalytics = () => ({
  type: CLEAR_NDT_ANALYTICS
});

